import { Routes, Route } from '@angular/router';
import { PublicShellComponent } from './public-shell.component';
import { AnonymousGuard } from '@core/services';

/**
 * Provides helper methods to create routes.
 */
export class PublicShell {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: PublicShellComponent,
      children: routes,
      canActivate: [AnonymousGuard]
    };
  }
}
